import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const allCompanyDetails = createAsyncThunk(
  "allCompanyDetails/fetch",
  async (data, { rejectWithValue, serializeError, dispatch }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetAllUsers?no_pagination=yes`
      );

      dispatch(setShowAlert(true));

      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const allCompanyDetailsSlice = createSlice({
  name: "allCompanyDetails",
  initialState: {
    companyData: {},
    companyDataStatus: "idle",
    error: null,
    showAlert: false,
  },
  reducers: {
    setShowAlert: (state, action) => {
      state.showAlert = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(allCompanyDetails.pending, (state, action) => {
        state.companyDataStatus = STATUSES.LOADING;
      })
      .addCase(allCompanyDetails.fulfilled, (state, action) => {
        state.companyData = action.payload;
        state.companyDataStatus = STATUSES.IDLE;
      })
      .addCase(allCompanyDetails.rejected, (state, action) => {
        state.companyDataStatus = STATUSES.ERROR;
      });
  },
});

export default allCompanyDetailsSlice.reducer;
export const { updateCreditStatus, setShowAlert } =
  allCompanyDetailsSlice.actions;
